import React from 'react';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import Steps, { Step } from 'rc-steps';
// import {FaCheckCircle} from "react-icons/fa";
// eslint-disable-next-line react/prop-types
const Icon = ({ type }) => <i className={`rcicon rcicon-${type}`} />;


export default class StepsNav extends React.Component {
    render(){
        const steps=[];
        for (let i = 1; i <= this.props.totalSteps; i += 1) {
            // const isActive = (this.props.currentStep) === i;
            let condProps = {};
            if (i <= this.props.stepsOpened){
                condProps.onClick = () => this.props.goToStep(i);
            }
            steps.push(
            <Step 
                        key={`step-${i}`}
                        title={(i < this.props.stepsOpened) ? i:''}
                        icon={ (false && i < this.props.stepsOpened) ? <Icon type="check-circle"  />:null }
                        {...condProps}
                        />
            );
        }
            return (
                <div >
                <Steps  current={this.props.stepsOpened-1 }>
                    {steps}
                </Steps>
                <br/>
                
                <br/>
                </div>
        );
    }
};